<template>
  <model-table
    :collection="page.sections"
    orderable
    :columns="[
      { field: 'id' },
      { field: 'name' },
      { field: 'type' },
      { name: 'Visibility', field: section => section.displayIcons, component: 'icons' },
      { name: 'library', field: section => page.originalSectionsByDraftId[section.id], component: 'library-link', hide: currentCircuit.isLibrary },
      { name: 'actions', align: 'right' }
    ]"
    :row-name="rowName"
    :cell-class="props => classesForSection(props.row)"
    :has-library="!currentCircuit.isLibrary && !$_.isNil(libraryCollection)"
    :library-collection="libraryCollection"
    @add="addSection()"
    @change="$emit('change')"
  >
    <section-form
      ref="sectionForm"
      :page="page"
      :handled-actions="['edit']"
    />
  </model-table>
</template>

<script>
import Page from 'src/models/page/Page'
import ModelTable from 'src/modules/admin/components/ModelTable'
import { defineAsyncComponent } from 'vue'

export default {
  name: 'SectionTable',
  components: {
    ModelTable,
    SectionForm: defineAsyncComponent(() => import('src/modules/admin/section/SectionForm'))
  },
  configuration: ['currentCircuit'],
  props: {
    page: {
      type: Page,
      required: true
    },
    libraryCollection: {
      type: Array,
      required: false,
      default: null
    }
  },
  emits: ['save', 'change'],
  computed: {
    rowName () {
      return (row) => `${row.name} of ${this.page.name}`
    }
  },
  methods: {
    addSection () {
      this.$refs.sectionForm.show(null, { pageId: this.page?.id })
    },
    classesForSection (section) {
      if (section.toDelete) {
        return ['bg-grey-4']
      }
    }
  }
}
</script>
